export const loaderSelector = state => state.loader;
